angular.module('FlexyBeautyApp.services')
    .factory('SaleSettings', [function () {
        return {
            UPDATE_CUSTOMER: "updateCustomer",
            DELETE_SERVICE: "deleteService",
            ADD_SERVICE: "addService",
            ADD_ITEM: "addItem",
            MOVE_HR: "moveHR",
            UPDATE_PRICE: "updatePrice",
            UPDATE_DISCOUNT: "updateDiscount",
            UPDATE_PAYMENT: "updatePayment",
            CANCEL_SALE: "cancelSale"
        };
    }])

    .factory('SalePartnerSettingsFactory', ['BasicAuthRoleFactory', function (BasicAuthRoleFactory) {
        return {
            checkSalePartnerSettings: function (setting, creator) {
                let checkSalePartnerSettings = true;
                if (setting && creator) {
                    let basicAuth = BasicAuthRoleFactory.getBasicAuthByBookingCreator(creator);
                    if (basicAuth && basicAuth.basicAuthRoleSaleCreationBehavior) {
                        checkSalePartnerSettings = basicAuth.basicAuthRoleSaleCreationBehavior[setting];
                    }
                }
                return checkSalePartnerSettings;
            }
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/views/ConstantsSaleSettings.js